import moment from "moment";
import { useEffect, useState } from "react";
import useNearScreen from "../../../../../hooks/useNearScreen";
import Avatar from "../../../../../parts/avatar";
import { useRillContext } from "../../../../../rill/RillReact/share/base";
import { getBodywweightAndUnit } from "../../../../../utils/converters/convert-units";
import { buildProgressPhotoPreviewHref } from "../../../../../utils/daily-stats";
import Photo from "./Photo";

const TimeLineItem = ({
  stat,
  type,
  choosing,
  selectPhotos,
  selectedPhotos,
  dailyStatId,
  utcDate,
  expandedList,
  isDragging,
}) => {
  const { locals } = useRillContext();
  const { activeUser, athlete } = locals;
  const { units } = activeUser;
  const { isNearScreen, elementRef } = useNearScreen();
  const [selected, setSelected] = useState(false);

  /**
   * Click handler for the timeline item.
   * If the user is choosing photos, it will select the photo.
   * If the user is not choosing photos, it will open the photo in a new tab.
   * @returns {void}
   */
  const handleClick = () => {
    selectPhotos(stat, type);
  };

  useEffect(() => {
    if (selectedPhotos.some((item) => item.stat === stat && item.key === type))
      setSelected(true);
    else setSelected(false);
  }, [selectedPhotos, stat]);
  const photo = stat.bodyPhotos?.[type];
  const photoThread = photo?.thread;
  const lastComment = photoThread?.lastComment;
  const lastCommentUser =
    lastComment?.sender ??
    [activeUser, athlete].find((user) => user._id === lastComment?.senderId);

  const previewHref = buildProgressPhotoPreviewHref(
    type,
    photo?.s3Path,
    photoThread?._id,
    dailyStatId,
    utcDate
  );

  return (
    <article
      ref={elementRef}
      style={{ cursor: isDragging ? "grabbing" : "grab" }}
    >
      {isNearScreen && (
        <>
          <div
            className="selectable"
            style={!choosing && previewHref ? { cursor: "pointer" } : {}}
          >
            <div className="progress-photo-wrapper">
              {lastComment?.message && (
                <div className="last-comment-wrapper">
                  <Avatar user={lastCommentUser} size={28} />
                  <div className="last-comment-message-wrapper">
                    <span className="last-comment-message">
                      {lastComment.message}
                    </span>
                    <div className="message-bubble-arrow" />
                  </div>
                </div>
              )}
              <a href={previewHref} className="progress-photo-link">
                <Photo
                  src={photo?.s3Path}
                  className={`progress-photo${expandedList ? " expanded" : ""}${
                    expandedList && expandedList !== type ? " phidden" : ""
                  }`}
                />
              </a>
            </div>

            {(selected || (choosing && selectedPhotos.length < 2)) && (
              <div
                className={`progress-item-overlay ${
                  selected ? "selected" : ""
                }`}
                onClick={handleClick}
              >
                <img
                  src={
                    !selected
                      ? "/img/new-icons/tick-circle-outline-white.svg"
                      : "/img/new-icons/close-circle-outline-white.svg"
                  }
                />
                <h2>{selected ? "Deselect" : "Select"}</h2>
              </div>
            )}
          </div>
          <footer>
            <time>
              {moment(stat.utcDate, "YYYYMMDD").format("MMM D, YYYY")}
            </time>
            <p>
              <b>
                {stat.bodyWeight
                  ? getBodywweightAndUnit(stat.bodyWeight, units)
                  : "- "}
              </b>
            </p>
          </footer>
        </>
      )}
    </article>
  );
};

export default TimeLineItem;
